import { CategoriaPolicy } from "./CategoriaPolicy";

export const categoriaPolicy = new CategoriaPolicy()